<template>
  <ul class="lg-aa-layout__conteudo__sidebar__container__menu">
    <li
      v-for="(menu, index) in menus"
      :key="menu.codigo + '__PanelMenu__' + index"
      :class="menuStyle(menu)"
      @click.stop="atualizarMenu(menu)"
      @keydown.enter="atualizarMenu(menu)"
    >
      <a tabindex="0">
        <i :class="menu.icone" />
        <span>{{ menu.descricao }}</span>
        <i v-if="menu.itens && menu.itens.length" class="pi pi-chevron-right" />
      </a>
      <LGPanelMenu v-if="menu.itens && menu.itens.length" :menus="menu.itens" :nivel="nivel + 1" />
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LGPanelMenu',
  props: {
    menus: {
      type: Array,
      required: true,
    },
    nivel: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters({
      getMenusAbertos: 'layout/getMenusAbertos',
    }),
    layoutEmPreview() {
      return this.$store.state.layout.preview;
    },
    menuAtivo: {
      set(menu) {
        this.$store.commit('layout/setMenuAtivo', menu.codigo);
      },
      get() {
        return this.$store.state.layout.menuAtivo;
      },
    },
    menuUid() {
      return this.$store.state.layout.menuUid;
    },
    menuAberto: {
      set(menu) {
        this.$store.commit('layout/setMenusAbertos', menu);
      },
      get() {
        return '';
      },
    },
    menuStyle() {
      return (menu) => ({
        'lg-aa-layout__conteudo__sidebar__container__menu__item--aberto': this.getMenusAbertos(
          menu.codigo,
        ),
        'lg-aa-layout__conteudo__sidebar__container__menu__item--ativo':
          this.menuAtivo === menu.codigo && (!this.menuUid || this.menuUid === menu.uid),
      });
    },
  },
  methods: {
    atualizarMenu(menu) {
      if (menu.itens && menu.itens.length) {
        this.menuAberto = { nivel: this.nivel, ...menu };
      } else {
        this.menuAtivo = menu;
        this.irParaARota(menu);
      }
    },
    irParaARota(menu) {
      if (this.layoutEmPreview === false) {
        if (menu.acao === 4) {
          let dadosMenu = this.$store.getters['layout/getMenuPorCodigo'](menu.codigo);

          if (!dadosMenu) {
            dadosMenu = this.$store.getters['layout/getMenuPorCodigo'](menu.codigo);
          }

          if (dadosMenu && dadosMenu.url) {
            this.$abrirFuncao(
              {
                url: dadosMenu.url,
                tipo: 0, // TIPO 0 = MENU
              },
              menu,
            );
          } else {
            this.abrirRotaPadrao(menu);
          }
        } else {
          this.abrirRotaPadrao(menu);
        }
      }
      this.$store.commit('layout/setSidebarAtiva', true);
    },
    abrirRotaPadrao(menu) {
      const acaoCustomizada = this.$store.getters['layout/getAcaoCustomizada'](menu.codigo);

      if (acaoCustomizada) {
        acaoCustomizada.call(this, menu);
      } else {
        this.$abrirFuncao(
          {
            tipo: 0, // TIPO 0 = MENU
          },
          menu,
        );
      }
    },
  },
};
</script>
